import { render, staticRenderFns } from "./HeaderDeadLock.vue?vue&type=template&id=65c5ece8&scoped=true&"
import script from "./HeaderDeadLock.vue?vue&type=script&lang=js&"
export * from "./HeaderDeadLock.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDeadLock.vue?vue&type=style&index=0&id=65c5ece8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c5ece8",
  null
  
)

export default component.exports